import { createContext } from 'react';

/**
 * Holds the unique identifier for the checkbox group.
 */
export var CheckboxGroupContext = /*#__PURE__*/createContext('');